import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import { MetaTags } from 'react-meta-tags';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'hooks/useAuth';
import GuidelineHeader from './components/Header';
import Breadcrumbs from '../../components/Breadcrumb';
import { ContentList } from './components/Content-List/index';
import { getDatabase, ref, onValue } from 'firebase/database';

const GuidelinesListBeta = () => {
  const { t: translate } = useTranslation();
  const { user } = useAuth();
  const accountId = user?.account;
  const userStatus = user?.adminStatus;
  const isAdminStatus = ['Super Admin', 'Admin'].includes(user.adminStatus);
  const navigate = useNavigate();
  const [guidelines, setGuidelines] = useState([]);

  useEffect(() => {
    if (!isAdminStatus) {
      navigate('/');
    }
  }, [isAdminStatus, navigate]);

  useEffect(() => {
    const db = getDatabase();
    const guidelinesRef = ref(db, `guidelines-v1/${accountId}`);

    const unsubscribe = onValue(guidelinesRef, (snapshot) => {
      const data = snapshot.val();
      const list = Object.entries(data ?? {})
        .filter(([key]) => key !== 'metadata')
        .map(([key, value]) => ({ ...value, id: key }))
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setGuidelines(list);
    });

    return () => unsubscribe();
  }, [accountId]);

  return (
    <div className="page-content">
      <MetaTags>
        <title>{`${translate('Content List')} | Ectools`}</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={translate('Content')} breadcrumbItem={translate('Content List')} />

        <GuidelineHeader accountId={accountId} userStatus={userStatus} />
        <div className="mt-4">
          <ContentList items={guidelines} />
        </div>
      </Container>
    </div>
  );
};

export default GuidelinesListBeta;
